import PropTypes from 'prop-types';
import style from '../ModalBoxWrapper.module.less';

function ModalBoxModal(props) {
	return <div className={style.modal}>{props.children}</div>;
}

ModalBoxModal.propTypes = {
	children: PropTypes.node,
};
ModalBoxModal.defaultProps = {
	children: null,
};

export default ModalBoxModal;
